import React from 'react';
import './About.css';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const services = [
    {
      image: '../img.jpg',
      icon: 'fas fa-user-cog',
      title: 'Mechanic',
      description: 'Our team of expert mechanics can handle all types of car repairs, from minor tune-ups to major overhauls. We use the latest diagnostic equipment to identify and fix any issues quickly and efficiently.',
      link: '/services/mechanic'
    },
    {
        image: '../img.jpg',
      icon: 'fas fa-bolt',
      title: 'Electrician',
        description: 'Our skilled electricians can troubleshoot and repair any electrical problems in your vehicle. From faulty wiring to dead batteries, we have the expertise to get your car back on the road in no time.',
        link: '/services/electrician'
    },
    {
        image: '../img.jpg',
      icon: 'fas fa-paint-roller',
      title: 'Car Painter',
        description: 'Our professional painters can give your car a fresh new look with our custom painting services. Whether you want to touch up a few scratches or completely change the color of your vehicle, we can help.',
        link: '/services/car-painter'
    },
    {
        image: '../img.jpg',
      icon: 'fas fa-car',
      title: 'Car Detailing',
        description: 'Our car detailing services will keep your vehicle looking like new. We offer interior and exterior cleaning, waxing, and polishing to help protect your car from the elements and maintain its value.',
        link: '/services/car-detailing'
    },
    {
        image: '../img.jpg',
      icon: 'fas fa-hammer',
      title: 'Car Dent Removal',
        description: 'Our dent removal services can restore your car to its original condition. We use specialized tools and techniques to remove dents without affecting the paint, so your vehicle looks as good as new.',
        link: '/services/dent-removal'
    },
  ];

export default function Services() {
  return (
    <>
    <div className='Main-sub-heading-div bordered '>
      <h1 className='Main-sub-heading-div-h1'>
          Our Services
      </h1>
      <p> 
        We provide a wide range of services to help you keep your vehicle
         in top condition. From routine maintenance to major repairs, 
         we have the expertise and resources to get the job done quickly 
         and efficiently. Some of the services we offer include:
      </p>
    </div>

    <div className="col-lg-12 services-section" style={{overflow: "hidden"}}>
          <h3 className="text-center py-8">Our Services</h3>
          <div className="services-list d-flex justify-content-center align-items-center row">
            {services.map((service) => (
              <motion.button
                icons={service.icon}
                key={service.title}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="btn btn-outline-secondary col-lg-3 mb-2 mx-2 services-item"
                style={{ fontSize: "2rem", borderRadius: "10px" }}
              >
                <div className="d-flex flex-column align-items-center">
                  <i className={service.icon} style={{ fontSize: "4rem", }}></i>
                  <h4 className="mb-0 ">{service.title}</h4>
                </div>
              </motion.button>
            ))}
          </div>
        </div>
        
    <div className="container-fluid py-5">
      {services.map((service, index) => (
        <React.Fragment key={service.title}>
          <div className="row align-items-center py-3">
            <div className="col-lg-6">
              <img src={service.image} className="img-fluid rounded" alt={service.title} />
            </div>
            <div className="col-lg-6">
              <h2 className="h1">{service.title}</h2>
              <p className="lead">{service.description}</p>
              <p className="lead">
                <Link to={service.link} className="btn btn-primary">
                  Learn More
                </Link>
              </p>
            </div>
          </div>
          {index !== services.length - 1 && (
            <hr className="my-5" />
          )}
        </React.Fragment>
      ))}
    </div>
    <style jsx>{`
    
    .services {
    color: #9a0002 !important;

    }
  `}</style>
    </>
  );
}
